var store = require('../store')

module.exports = {
  replace: true,
  data: function () {
    return {
      open: true,
      comments: null
    }
  },
  created: function () {
    if (this.kids) {
      store.fetchItems(this.kids, function (comments) {
        this.comments = comments
      }.bind(this))
    }
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ../vue-loader/lib/selector.js?script!./src/components/comment.vue
 ** module id = 99
 ** module chunks = 0
 **/